import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AtencionCliente.css';

const LogoComunicar = ({ height = 40 }) => (
  <svg height={height} viewBox="0 0 300 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="20" cy="28" rx="14" ry="12" fill="#82D8B3" opacity="0.7"/>
    <path d="M10 38 Q6 44 4 48 Q11 43 16 40Z" fill="#82D8B3" opacity="0.7"/>
    <ellipse cx="34" cy="22" rx="20" ry="17" fill="#82D8B3"/>
    <path d="M20 36 Q16 44 13 48 Q22 42 27 38Z" fill="#82D8B3"/>
    <circle cx="27" cy="22" r="2.2" fill="white"/>
    <circle cx="34" cy="22" r="2.2" fill="white"/>
    <circle cx="41" cy="22" r="2.2" fill="white"/>
    <text x="62" y="24" fontFamily="'DM Sans', sans-serif" fontWeight="700" fontSize="16" fill="#4db88a">Centro Comunicar</text>
    <text x="64" y="38" fontFamily="'DM Sans', sans-serif" fontWeight="400" fontSize="10" fill="#888">Comunicar - Lenguaje, Aprendizaje y Habla</text>
  </svg>
);

const IconWhatsapp  = () => <svg viewBox="0 0 24 24" fill="none" width="22" height="22"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconMail      = () => <svg viewBox="0 0 24 24" fill="none" width="22" height="22"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconClock     = () => <svg viewBox="0 0 24 24" fill="none" width="22" height="22"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconBook      = () => <svg viewBox="0 0 24 24" fill="none" width="22" height="22"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconCheck     = () => <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.2)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconSpinner   = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'ac-spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconArrow     = () => <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconUser      = () => <svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;

const CANALES = [
  {
    id: 'whatsapp',
    Icon: IconWhatsapp,
    titulo: 'WhatsApp',
    desc: 'Respuesta rapida en horario de atencion. Ideal para consultas sobre cursos y materiales.',
    detalle: '+51 940 686 868',
    color: '#22c55e',
    bg: 'linear-gradient(135deg,#bbf7d0,#86efac)',
    href: 'https://wa.me/51940686868?text=Hola%2C%20necesito%20ayuda%20con%20mi%20compra%20en%20Centro%20Comunicar',
    cta: 'Escribir por WhatsApp',
  },
  {
    id: 'email',
    Icon: IconMail,
    titulo: 'Correo electronico',
    desc: 'Para consultas detalladas, facturas, accesos y solicitudes formales. Respondemos en 24-48h.',
    detalle: 'terapias.comunicar@gmail.com',
    color: '#3b82f6',
    bg: 'linear-gradient(135deg,#dbeafe,#93c5fd)',
    href: 'mailto:terapias.comunicar@gmail.com?subject=Consulta%20-%20Centro%20Comunicar',
    cta: 'Enviar correo',
  },
];

const FAQS = [
  {
    q: 'No puedo acceder a mi curso despues de comprarlo',
    a: 'Verifica que hayas creado tu cuenta con el mismo email con el que realizaste la compra. Si el problema persiste, escríbenos por WhatsApp con el codigo de tu pedido y lo resolvemos en minutos.',
  },
  {
    q: 'Mi descarga no funciona o el archivo esta incompleto',
    a: 'Intenta descargar nuevamente desde "Mi cuenta". Si el archivo sigue con problemas, escríbenos e indicanos el nombre del recurso y te enviamos el archivo directamente.',
  },
  {
    q: 'Realize un pago pero no recibi confirmacion',
    a: 'Revisa tu carpeta de spam. Si no encuentras el correo, escríbenos con el comprobante de pago (captura o numero de operacion) y activamos tu acceso manualmente.',
  },
  {
    q: 'Quiero solicitar una factura o boleta electronica',
    a: 'Escríbenos al correo con tu RUC o DNI, el monto pagado y la fecha de compra. Emitimos el comprobante en un plazo de 48 horas habiles.',
  },
  {
    q: 'Como cancelo mi suscripcion al boletin',
    a: 'En cada correo del boletin encontraras un enlace "Darse de baja" al pie del mensaje. Tambien puedes escribirnos y lo hacemos directamente.',
  },
  {
    q: 'Tengo un reclamo formal sobre un producto o servicio',
    a: 'Puedes registrar tu reclamo en nuestro Libro de Reclamaciones virtual, disponible en el siguiente enlace. Atendemos en un plazo maximo de 30 dias habiles segun la Ley N 29571.',
  },
];

const INIT_FORM = { nombre: '', email: '', asunto: '', mensaje: '', tipo: 'consulta' };

export default function AtencionCliente() {
  const [form,      setForm]      = useState(INIT_FORM);
  const [enviando,  setEnviando]  = useState(false);
  const [enviado,   setEnviado]   = useState(false);
  const [error,     setError]     = useState('');
  const [faqOpen,   setFaqOpen]   = useState(null);

  function set(campo, valor) {
    setForm(function(prev) { return Object.assign({}, prev, { [campo]: valor }); });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!form.nombre.trim())         { setError('Ingresa tu nombre'); return; }
    if (!form.email.includes('@'))   { setError('Email no valido'); return; }
    if (!form.asunto.trim())         { setError('Ingresa un asunto'); return; }
    if (form.mensaje.trim().length < 10) { setError('El mensaje es muy corto'); return; }
    setEnviando(true);
    try {
      var res = await fetch('https://centrocomunicar.com/api-comunicar/endpoints/atencion.php?action=contacto', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      var json = await res.json();
      if (!json.success) throw new Error(json.message || 'Error al enviar');
      setEnviado(true);
      setForm(INIT_FORM);
    } catch(err) {
      setError(err.message || 'Error al enviar. Escríbenos por WhatsApp.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="ac-page">

      {/* NAV */}
      <nav className="ac-nav">
        <Link to="/" className="ac-nav__logo"><LogoComunicar height={42}/></Link>
        <Link to="/" className="ac-nav__back">← Volver al inicio</Link>
      </nav>

      {/* HEADER */}
      <div className="ac-header">
        <div className="ac-header__inner">
          <p className="ac-header__label">Estamos para ayudarte</p>
          <h1>Atencion <em>al cliente</em></h1>
          <p className="ac-header__sub">
            Resolvemos tus consultas sobre cursos, materiales, pagos y accesos.
            Elige el canal que prefieras o completa el formulario.
          </p>
        </div>
      </div>

      <div className="ac-body">

        {/* CANALES */}
        <div className="ac-canales">
          {CANALES.map(function(c) {
            return (
              <a key={c.id} href={c.href} target="_blank" rel="noopener noreferrer" className="ac-canal">
                <div className="ac-canal__thumb" style={{background: c.bg}}>
                  <div className="ac-canal__icon" style={{color: c.color}}><c.Icon/></div>
                </div>
                <div className="ac-canal__body">
                  <h3>{c.titulo}</h3>
                  <p>{c.desc}</p>
                  <span className="ac-canal__detalle">{c.detalle}</span>
                </div>
                <div className="ac-canal__footer">
                  <span className="ac-canal__btn" style={{background: c.color}}>
                    {c.cta} <IconArrow/>
                  </span>
                </div>
              </a>
            );
          })}

          {/* Horario */}
          <div className="ac-canal ac-canal--info">
            <div className="ac-canal__thumb" style={{background:'linear-gradient(135deg,#fef3c7,#fde68a)'}}>
              <div className="ac-canal__icon" style={{color:'#d97706'}}><IconClock/></div>
            </div>
            <div className="ac-canal__body">
              <h3>Horario de atencion</h3>
              <div className="ac-horario">
                <div><span>Lunes a viernes</span><strong>9:00 am - 6:00 pm</strong></div>
                <div><span>Sabados</span><strong>9:00 am - 1:00 pm</strong></div>
                <div><span>Domingos y feriados</span><strong>Cerrado</strong></div>
              </div>
            </div>
          </div>

          {/* Libro de reclamaciones */}
          <div className="ac-canal ac-canal--reclamo">
            <div className="ac-canal__thumb" style={{background:'linear-gradient(135deg,#fee2e2,#fca5a5)'}}>
              <div className="ac-canal__icon" style={{color:'#dc2626'}}><IconBook/></div>
            </div>
            <div className="ac-canal__body">
              <h3>Libro de Reclamaciones</h3>
              <p>Si tienes una disconformidad formal con nuestros productos o servicios, puedes registrarla aqui. Respondemos en un maximo de 30 dias habiles segun la Ley N 29571.</p>
            </div>
            <div className="ac-canal__footer">
              <Link to="/libro-reclamaciones" className="ac-canal__btn" style={{background:'#dc2626'}}>
                Ir al libro de reclamaciones <IconArrow/>
              </Link>
            </div>
          </div>
        </div>

        {/* FORMULARIO + FAQ */}
        <div className="ac-content">

          {/* Formulario */}
          <div className="ac-form-wrap">
            <div className="ac-form-head">
              <IconUser/>
              <div>
                <h2>Formulario de contacto</h2>
                <p>Te respondemos en un plazo de 24 a 48 horas habiles.</p>
              </div>
            </div>

            {enviado ? (
              <div className="ac-form-ok">
                <div className="ac-form-ok__icon">
                  <svg viewBox="0 0 24 24" fill="none" width="36" height="36">
                    <circle cx="12" cy="12" r="10" fill="#d4f4e8"/>
                    <path d="M8 12l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>Mensaje enviado</h3>
                <p>Hemos recibido tu consulta. Te responderemos al correo indicado en un plazo de 24-48 horas habiles.</p>
                <button className="ac-btn ac-btn--ghost" onClick={function() { setEnviado(false); }}>
                  Enviar otra consulta
                </button>
              </div>
            ) : (
              <form className="ac-form" onSubmit={handleSubmit}>
                {error && <div className="ac-form-error">{error}</div>}

                <div className="ac-campo">
                  <label>Tipo de consulta</label>
                  <div className="ac-tipo-group">
                    {[
                      {val:'consulta',   label:'Consulta general'},
                      {val:'pago',       label:'Pago o factura'},
                      {val:'acceso',     label:'Acceso a curso'},
                      {val:'descarga',   label:'Descarga de material'},
                      {val:'otro',       label:'Otro'},
                    ].map(function(op) {
                      return (
                        <label key={op.val} className={'ac-tipo ' + (form.tipo === op.val ? 'ac-tipo--active' : '')}>
                          <input type="radio" name="tipo" value={op.val} checked={form.tipo === op.val} onChange={function(e) { set('tipo', e.target.value); }}/>
                          {op.label}
                        </label>
                      );
                    })}
                  </div>
                </div>

                <div className="ac-grid-2">
                  <div className="ac-campo">
                    <label>Nombre completo <span className="ac-req">*</span></label>
                    <input type="text" placeholder="Ej: Ana Garcia" value={form.nombre} onChange={function(e) { set('nombre', e.target.value); }} required/>
                  </div>
                  <div className="ac-campo">
                    <label>Correo electronico <span className="ac-req">*</span></label>
                    <input type="email" placeholder="tu@correo.com" value={form.email} onChange={function(e) { set('email', e.target.value); }} required/>
                  </div>
                </div>

                <div className="ac-campo">
                  <label>Asunto <span className="ac-req">*</span></label>
                  <input type="text" placeholder="Describe brevemente tu consulta" value={form.asunto} onChange={function(e) { set('asunto', e.target.value); }} required/>
                </div>

                <div className="ac-campo">
                  <label>Mensaje <span className="ac-req">*</span></label>
                  <textarea rows={5} placeholder="Escribe aqui todos los detalles de tu consulta. Si es sobre un pago, incluye el numero de operacion o captura." value={form.mensaje} onChange={function(e) { set('mensaje', e.target.value); }} required/>
                  <span className="ac-contador">{form.mensaje.length} caracteres</span>
                </div>

                <button type="submit" className="ac-btn ac-btn--primary" disabled={enviando}>
                  {enviando
                    ? <span><IconSpinner/> Enviando...</span>
                    : <span><IconMail/> Enviar consulta</span>
                  }
                </button>

                <p className="ac-form-legal">
                  <IconCheck/> Tus datos son confidenciales y solo se usan para atender tu consulta.
                </p>
              </form>
            )}
          </div>

          {/* FAQ */}
          <div className="ac-faq">
            <h2 className="ac-faq__titulo">Preguntas frecuentes</h2>
            <div className="ac-faq__lista">
              {FAQS.map(function(faq, i) {
                var abierto = faqOpen === i;
                return (
                  <div key={i} className={'ac-faq__item ' + (abierto ? 'ac-faq__item--open' : '')}>
                    <button className="ac-faq__q" onClick={function() { setFaqOpen(abierto ? null : i); }}>
                      <span>{faq.q}</span>
                      <span className="ac-faq__chevron">{abierto ? '−' : '+'}</span>
                    </button>
                    {abierto && (
                      <div className="ac-faq__a">
                        <p>{faq.a}</p>
                        {i === 5 && (
                          <Link to="/libro-reclamaciones" className="ac-faq__link">
                            Ir al Libro de Reclamaciones <IconArrow/>
                          </Link>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>

      {/* FOOTER MINI */}
      <div className="ac-footer">
        <div className="ac-footer__inner">
          <LogoComunicar height={30}/>
          <p>COMUNICAR DESARROLLO Y LENGUAJE EIRL | RUC: 20615646939 | centrocomunicar.com</p>
          <div className="ac-footer__links">
            <Link to="/legal">Legal y privacidad</Link>
            <Link to="/libro-reclamaciones">Libro de reclamaciones</Link>
            <Link to="/">Volver al inicio</Link>
          </div>
        </div>
      </div>

    </div>
  );
}